import React, { useState } from "react";
import HeroSectionImageSlider from "../Components/HeroSectionImageSlider";
import NirjalaEkdasiBanner from "../assets/NirjalaEkadasi2026.webp";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import AccountDetails from "../Components/AccountDetails";
import thaliImg from "../assets/AnadaanThali.webp";
import AdoptCow from "../assets/AdoptCow.webp";
import axios from "axios";
import AnnaDaan from "../Components/AnnaDaan";
import { Helmet } from "react-helmet-async";
const NirjalaEkdasi = () => {
  const [donations, setDonations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    purpose: "",
  });
  const [loading, setLoading] = useState(false);
  const [customAmount, setCustomAmount] = useState("");
  const [errors, setErrors] = useState({});
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^\d*$/.test(value)) return;
    if (name === "phone" && value.length > 10) return;
    setForm({ ...form, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleContinueToPay = async () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "Name is required.";
    if (!form.phone) newErrors.phone = "Phone number is required.";
    else if (form.phone.length !== 10)
      newErrors.phone = "Enter a valid 10-digit phone number.";
    if (!form.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      newErrors.email = "Enter a valid email address.";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        { amount: totalAmount, currency: "INR" },
      );
      const order = res.data;
      //if (!order.id) throw new Error("Order creation failed");
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        // amount: order.amount,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Vijayawada Nirjala Ekadashi",
        description: donations.map((d) => d.label).join(", "),
        order_id: order.id,
        handler: async function (response) {
          try {
            const verifyRes = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: {
                  amount: totalAmount,
                  donor: form,
                  items: donations.map((d) => ({
                    label: d.label,
                    price: d.price,
                  })),
                },
              },
            );
            if (verifyRes.data.success) {
              await storeFormData("Success");
              alert("Payment successful! Thank you for your donation.");
              setShowModal(false);
            }
          } catch (err) {
            console.error(err);
            await storeFormData("Payment Failed");
            alert("Payment verification failed. Please contact support.");
          }
        },
        prefill: {
          name: form.name,
          email: form.email,
          contact: `+91${form.phone}`,
        },
        theme: { color: "#C61D21" },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
      rzp.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
      });
    } catch (err) {
      alert("Something went wrong. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const storeFormData = async (paymentStatus) => {
    const storingFormData = {
      PaymentStatus: paymentStatus,
      Name: form.name,
      Email: form.email,
      Number: form.phone,
      Festival: "Nirjala Ekadashi",
      Seva: donations.map((d) => `${d.label} (₹${d.price})`).join(", "),
      Details: form.purpose || "None",
      Amount: totalAmount,
      Date: new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    };
    const formBody = new URLSearchParams(storingFormData).toString();
    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbzrkFAKB06oncKz_K-NuGI9IfEfftYdr0s9VDSn_tnilCq-r3Lni2WcSQy4SzidUdhW/exec",
        {
          method: "POST",
          body: formBody,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      );
      setForm({ name: "", phone: "", email: "", purpose: "" });
      setDonations([]);
      setCustomAmount("");
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Some error occured");
    }
  };
  const toggleDonation = (label, price, img) => {
    setDonations((prev) =>
      prev.find((d) => d.label === label)
        ? prev.filter((d) => d.label !== label)
        : [...prev, { label, price, img }],
    );
  };
  const handleCustomDonation = () => {
    const amount = parseInt(customAmount);
    if (!amount || amount < 1) return;
    const label = "Donation As You Wish";
    setDonations((prev) => [
      ...prev.filter((d) => d.label !== label),
      { label, price: amount, img: thaliImg },
    ]);
    setCustomAmount("");
  };
  const totalAmount = donations.reduce((sum, d) => sum + d.price, 0);
  const firstLabel = donations[0]?.label || "";
  const extraCount = donations.length - 1;
  const displayLabel =
    donations.length === 0
      ? ""
      : extraCount > 0
        ? `${firstLabel} + ${extraCount} more`
        : firstLabel;
  return (
    <>
      <Helmet>
        <title>Nirjala Ekadashi Seva 2026 – ISKCON Vijayawada | Donate & Earn Divine Blessings</title>
        <meta
          name="description"
          content="Celebrate Nirjala Ekadashi 2026 with ISKCON Vijayawada. Sponsor Anna Daan, Gau Seva, and more sevas on this most powerful fasting day. Earn divine blessings of Lord Vishnu."
        />
        <meta
          name="keywords"
          content="Nirjala Ekadashi 2026, Nirjala Ekadashi ISKCON Vijayawada, Ekadashi fasting donation, Anna Daan Nirjala Ekadashi, Gau Seva Ekadashi, ISKCON Vijayawada Ekadashi seva, Nirjala Ekadashi significance"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Nirjala Ekadashi Seva 2026 – ISKCON Vijayawada | Donate & Earn Divine Blessings"
        />
        <meta
          property="og:description"
          content="Celebrate Nirjala Ekadashi 2026 with ISKCON Vijayawada. Sponsor Anna Daan, Gau Seva, and more sevas on this most powerful fasting day. Earn divine blessings of Lord Vishnu."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/ekadasi"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Nirjala Ekadashi Seva 2026 – ISKCON Vijayawada | Donate & Earn Divine Blessings"
        />
        <meta
          name="twitter:description"
          content="Celebrate Nirjala Ekadashi 2026 with ISKCON Vijayawada. Sponsor Anna Daan, Gau Seva, and more sevas on this most powerful fasting day. Earn divine blessings of Lord Vishnu."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/ekadasi"
        />
      </Helmet>
      <Header />
      <HeroSectionImageSlider
        slides={[
          { img: NirjalaEkdasiBanner },
        ]}
      />
      {/* Anna Daan */}
      <AnnaDaan donations={donations} toggleDonation={toggleDonation} />
      {/* Adopt a Cow */}
      <div className="md:px-12 px-6 lg:px-8 py-6 sm:py-8">
        <h2 className="text-red text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 inline-block pb-1">
          Adopt a Cow
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {[
            { duration: "1 Month", price: 3000 },
            { duration: "3 Months", price: 9000 },
            { duration: "6 Months", price: 18000 },
            { duration: "1 Year", price: 36000 },
          ].map(({ duration, price }) => {
            const label = `Adopt 1 Cow for ${duration}`;
            const added = donations.some((d) => d.label === label);
            return (
              <div
                key={duration}
                className="bg-gray-100 border border-rose-700 rounded-lg p-3 sm:p-4 flex items-center justify-between gap-2"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={AdoptCow}
                    alt="cow"
                    className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="text-black font-semibold text-xs sm:text-sm">
                      {label}
                    </p>
                    <p className="text-black text-xs sm:text-sm mt-1">
                      ₹{price.toLocaleString()}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => toggleDonation(label, price, AdoptCow)}
                  className={`text-xs sm:text-sm px-2 sm:px-4 py-2 rounded transition-colors whitespace-nowrap flex-shrink-0 ${
                    added
                      ? "bg-gray-400 text-white hover:bg-gray-500"
                      : "bg-red text-white hover:bg-darkred"
                  }`}
                >
                  {added ? "Remove" : "Add Donation"}
                </button>
              </div>
            );
          })}
        </div>
      </div>
      {/* Donation As You Wish */}
      <div className="md:px-12 px-6 lg:px-8 py-4 sm:py-6">
        <div className="relative rounded-2xl overflow-hidden border border-rose-700 bg-gradient-to-r from-rose-50 to-orange-50">
          {/* Decorative top strip */}
          <div className="h-1.5 w-full bg-gradient-to-r from-rose-600 to-orange-400" />
          <div className="p-5 flex flex-col sm:flex-row items-center gap-6">
            {/* Icon + Text */}
            <div className="flex flex-col items-center sm:items-start  sm:w-56 flex-shrink-0 text-center sm:text-left">
              <p className="text-red font-semibold md:text-xl ">
                Donation As You Wish
              </p>
              <p className="text-gray-500 text-sm">Contribute any amount</p>
            </div>
            {/* Divider */}
            <div className="hidden sm:block w-px h-16 bg-rose-200" />
            {/* Input + Button */}
            <div className="flex flex-1 flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full">
              <div className="flex items-center bg-white border-2 border-rose-300 focus-within:border-rose-500 rounded-xl px-3 py-2 gap-2 flex-1 transition-colors">
                {/* <span className="text-rose-600 font-bold text-lg">₹</span> */}
                <input
                  type="text"
                  inputMode="numeric"
                  value={customAmount}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value))
                      setCustomAmount(e.target.value);
                  }}
                  placeholder="Enter your amount"
                  className="bg-transparent  flex-1  text-gray-800 placeholder-gray-400 focus:outline-none font-medium"
                />
                {customAmount && (
                  <span className="text-xs text-gray-400 whitespace-nowrap">
                    ₹ {parseInt(customAmount).toLocaleString("en-IN")}
                  </span>
                )}
              </div>
              <button
                onClick={handleCustomDonation}
                className="bg-red hover:bg-darkred text-white font-bold px-8 py-3 rounded-xl transition-colors text-sm whitespace-nowrap shadow-md"
              >
                + Add Donation
              </button>
            </div>
          </div>
        </div>
      </div>
      <AccountDetails donateLink="https://rzp.io/rzp/H3NMKYC" />
      <div className="mx-4 md:mx-12 my-6 p-6  border border-red rounded-lg shadow-sm">
        <div className="flex items-start">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Gentle Request!
            </h3>
            <p className="text-gray-700 leading-relaxed  text-sm m-0">
              While doing Paytm/UPI App Payments or Bank (NEFT/RTGS) please send
              us a screenshot along with complete address and PAN details on our
              contact details: WhatsApp{" "}
              <a
                href="https://wa.me/919955685568"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                +91-9955685568{" "}
              </a>
              Email:{" "}
              <a
                href="mailto:seva@iskconvijayawada.org"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                seva@iskconvijayawada.org{" "}
              </a>
              You may also call on the above number for other queries.
            </p>
          </div>
        </div>
      </div>
      <Footer />
      {/* Sticky Donation Bar */}
      {donations.length > 0 && (
        <div className="fixed bottom-12 md:bottom-0  left-0 right-0 z-50 bg-gray-300 text-black px-4 sm:px-8 py-3 flex items-center justify-between gap-4 shadow-2xl">
          <div className="flex flex-col min-w-0">
            <span className="text-xs text-gray-800">Donating for</span>
            <span className="text-sm font-bold underline truncate">
              {displayLabel}
            </span>
          </div>
          <div className="flex items-center gap-3 sm:gap-6 flex-shrink-0">
            <div className="text-right">
              <p className="text-xs text-gray-800">Total Amount:</p>
              <p className="text-base sm:text-lg font-bold">
                ₹{" "}
                {totalAmount.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
            <button
              onClick={() => setShowModal(true)}
              className="bg-red text-white font-bold px-5 sm:px-8 py-2 sm:py-3 rounded text-sm sm:text-base transition-colors whitespace-nowrap"
            >
              Pay Now
            </button>
          </div>
        </div>
      )}
      {/* Pay Now Modal */}
      {showModal && (
        <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4">
          <div className="bg-gray-200  rounded-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 relative">
            {/* Close */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 hover:bg-gray-300  w-8 h-8 rounded flex items-center justify-center text-lg"
            >
              ✕
            </button>
            {/* Title */}
            <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
              <span className="w-1 h-7 bg-red inline-block rounded"></span>
              Donate with love
            </h2>
            <div className="flex flex-col md:flex-row gap-2">
              {/* Form */}
              <div className="flex-1 border bg-white rounded-xl py-5 px-4 flex flex-col gap-4">
                <p className=" text-sm">
                  Please fill required fields to continue
                </p>
                <div className="flex flex-col gap-1">
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleFormChange}
                    placeholder="Your Legal Name"
                    className={`bg-transparent border rounded-lg px-4 py-3 text-sm placeholder-gray-500 focus:outline-none ${errors.name ? "border-red" : "border-gray-600 focus:border-gray-400"}`}
                  />
                  {errors.name && (
                    <p className="text-red text-xs px-1">{errors.name}</p>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <div
                    className={`flex items-center border rounded-lg px-4 py-3 gap-2 ${errors.phone ? "border-red" : "border-gray-600"}`}
                  >
                    <span className="text-lg">🇮🇳</span>
                    <span className="text-sm">+91</span>
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={handleFormChange}
                      placeholder="Phone Number"
                      inputMode="numeric"
                      className="bg-transparent flex-1 text-sm placeholder-gray-500 focus:outline-none"
                    />
                  </div>
                  {errors.phone && (
                    <p className="text-red text-xs px-1">{errors.phone}</p>
                  )}
                </div>
                <div className="flex flex-col gap-1">
                  <input
                    name="email"
                    value={form.email}
                    onChange={handleFormChange}
                    placeholder="Your Email-Id"
                    className={`bg-transparent border rounded-lg px-4 py-3 text-sm placeholder-gray-500 focus:outline-none ${errors.email ? "border-red" : "border-gray-600 focus:border-gray-400"}`}
                  />
                  {errors.email && (
                    <p className="text-red text-xs px-1">{errors.email}</p>
                  )}
                </div>
                <input
                  name="purpose"
                  value={form.purpose}
                  onChange={handleFormChange}
                  placeholder="Purpose of Donation"
                  className="bg-transparent border border-gray-600 rounded-lg px-4 py-3 text-sm  placeholder-gray-500 focus:outline-none focus:border-gray-400"
                />
              </div>
              {/* Donation Details */}
              <div className="w-full md:w-1/2 border bg-white rounded-xl py-5 px-4 flex flex-col gap-3">
                <h3 className="font-bold text-base">Donation Details</h3>
                <div className="flex flex-col gap-3">
                  {donations.map((d) => (
                    <div key={d.label} className="flex items-center gap-3">
                      <img
                        src={d.img}
                        alt=""
                        className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
                      />
                      <div className="">
                        <p className="font-bold text-sm m-0 max-w-[140px]">
                          {d.label.length > 16
                            ? d.label.slice(0, 16) + "..."
                            : d.label}
                        </p>
                        <p className=" text-xs m-0">{d.label}</p>
                        <p className="text-red m-0 font-semibold text-xs">
                          ₹{d.price.toLocaleString()}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <hr className="border-gray-600" />
                <div className="flex justify-between font-bold text-base">
                  <span>Total</span>
                  <span>₹ {totalAmount.toLocaleString()}</span>
                </div>
              </div>
            </div>
            {/* Continue to Pay */}
            <div className="mt-6 flex justify-end">
              <button
                onClick={handleContinueToPay}
                disabled={loading}
                className="bg-red hover:bg-darkred text-white font-bold px-10 py-3 rounded-lg text-base transition-colors w-full disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? "Processing..." : "Continue to Pay"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default NirjalaEkdasi;
